import moment from 'moment';
/**
 *  @param fmatStr - format string, e.g. 'YYYY-MM-DD HH:mm:ss'
 *  @param date - date object or timestamp
 *  @returns {string} - formatted date string
*/
export const dateFormat = (fmatStr,date) => {
    if (!date) {
        date = new Date();
    }
    let str = fmatStr;
    let Week = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    str=str.replace(/yyyy|YYYY/,date.getFullYear());   
    str=str.replace(/yy|YY/,(date.getYear() % 100)>9?(date.getYear() % 100).toString():'0' + (date.getYear() % 100));   

    str=str.replace(/MM/,(date.getMonth() + 1)>9?(date.getMonth() + 1).toString():'0' + (date.getMonth() + 1));   
    str=str.replace(/M/g,(date.getMonth() + 1));   

    //return moment(date).format(fmatStr);
    str=str.replace(/w|W/g,Week[date.getDay()]);   
    str=str.replace(/dd|DD/,date.getDate()>9?date.getDate().toString():'0' + date.getDate());   
    str=str.replace(/d|D/g,date.getDate());   

    str=str.replace(/hh|HH/,date.getHours()>9?date.getHours().toString():'0' + date.getHours());   
    str=str.replace(/h|H/g,date.getHours());   
    str=str.replace(/mm/,date.getMinutes()>9?date.getMinutes().toString():'0' + date.getMinutes());   
    str=str.replace(/m/g,date.getMinutes());   
    str=str.replace(/ss|SS/,date.getSeconds()>9?date.getSeconds().toString():'0' + date.getSeconds());   
    str=str.replace(/s|S/g,date.getSeconds());   
    return str;   
}

/**
 * console print for debugging purpose
 * @param {string} tag - tag for the log message
 * @param {string} msg - log message
 * @returns {void}
*/
export const ePortalLog = (tag, msg) => {
    if(!window.console)
    {
        return;
    }
    let tMsg = "" + tag + " " + dateFormat("yyyy-MM-DD HH:mm:ss", new Date()) + " >" + msg;
    switch(tag)
    {
        case "[D]":
            if(console.debug)
            {
                console.debug(tMsg);
            }else{
                console.info(tMsg);
            }
            break;
        case "[I]":
            console.info(tMsg);
            break;
        case "[E]":
            console.error(tMsg);
            break;
        default:
        console.log(tMsg);
    }
}